export const API_STATUSES = [
  'active',
  'inactive',
];
